import type { LinkOptions, RegisteredRouter } from '@tanstack/react-router';

import { Separator } from '@connected/ui/components/separator';
import { Link } from '@tanstack/react-router';

export type NavItem = {
    label: string;
    link?: string;
    params?: Record<string, string>;
    search?: Record<string, string | undefined>;
};

export type NavRoute<
    TRouter extends RegisteredRouter = RegisteredRouter,
    TFrom extends string = string,
    TTo extends string = '',
> = Omit<LinkOptions<TRouter, TFrom, TTo>, 'search' | 'params'> & {
    label: string;
    search?: Record<string, string | undefined>;
};

export type SubmenuNavigationProps = {
    items: NavRoute[];
};

export function SubmenuNavigation({ items }: SubmenuNavigationProps) {
    return (
        <>
            <div className="flex items-center">
                {items.map((item, index) => {
                    // @ts-expect-error fix type issue with LinkOptions
                    const { label, to, params, search } = item;

                    // If no link is provided, render as disabled
                    if (!to) {
                        return (
                            <span
                                key={`nav-item-${label}`}
                                className={`pb-2 ${index > 0 ? 'ml-4' : ''} transition duration-200 text-text-primary/60 cursor-not-allowed`}
                            >
                                {label}
                            </span>
                        );
                    }

                    // Render as an active link
                    return (
                        <Link
                            key={`nav-item-${label}`}
                            to={to}
                            params={params}
                            search={search as any}
                            className={`${index > 0 ? 'ml-4' : ''} transition duration-200`}
                            inactiveProps={{
                                className:
                                    'pb-2 font-semibold text-text-black hover:text-primary hover:border-b-2 border-primary',
                            }}
                            activeProps={{
                                className:
                                    'pb-2 font-semibold text-primary hover:!text-primary border-b-2 border-primary',
                            }}
                        >
                            {label}
                        </Link>
                    );
                })}
            </div>
            <Separator className="mb-10" />
        </>
    );
}
